/*
  IW Nuevo product page: restock notify card (phase 2.2, T16). Loaded by snippets/iw-restock-notify.liquid.

  The card is a small state machine. The root [data-iw-notify] carries data-state and assets/iw-pdp.css draws each
  state from it:
    idle      the form, waiting for an email
    invalid   the email is wrong (client check or a 400 "Correo inválido"): field and message in dark orange
    sending   the request is in flight: field and button disabled, spinner
    neterror  the service could not save the alert (network, timeout, non-JSON, 5xx, other 4xx): amber box, the button
              says "Intentar de nuevo" and resubmits
    success   the form is replaced by a confirmation that offers "Usar otro correo"

  Events are delegated on the document, so the card keeps working if the product section is swapped in place.

  Focus: invalid goes back to the field, a service error goes to the retry button, success moves focus to the
  confirmation (the form it came from is gone) and "Usar otro correo" puts it back on the field.

  The honeypot "hp" travels in the body; the service answers 200 without saving when it is filled.
*/
(function () {
  if (window.iwRestockNotify) return;
  window.iwRestockNotify = true;

  // Same rule as the service (importwave-restock, src/server.ts).
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  var TIMEOUT_MS = 10000;

  function parts(root) {
    return {
      input: root.querySelector('[data-notify-input]'),
      field: root.querySelector('[data-notify-field]'),
      error: root.querySelector('[data-notify-error]'),
      net: root.querySelector('[data-notify-neterror]'),
      btn: root.querySelector('[data-notify-btn]'),
      hp: root.querySelector('[data-notify-hp]'),
      formView: root.querySelector('[data-notify-form-view]'),
      done: root.querySelector('[data-notify-done]'),
      email: root.querySelector('[data-notify-email]'),
    };
  }

  function setState(root, state) {
    var p = parts(root);
    var sending = state === 'sending';
    var invalid = state === 'invalid';

    root.dataset.state = state;
    p.input.disabled = sending;
    p.btn.disabled = sending;
    p.btn.setAttribute('aria-busy', sending ? 'true' : 'false');
    p.input.setAttribute('aria-invalid', invalid ? 'true' : 'false');
    // The error is only part of the description while it is on screen (a hidden element still counts otherwise).
    p.input.setAttribute('aria-describedby', root.dataset.hintId + (invalid ? ' ' + root.dataset.errorId : ''));
    p.error.hidden = !invalid;
    p.net.hidden = state !== 'neterror';
    p.formView.hidden = state === 'success';
    p.done.hidden = state !== 'success';
  }

  // The variant that is selected right now (the product form keeps it up to date on every change).
  function currentVariant(root) {
    var input = document.querySelector('#product-form-' + root.dataset.sectionId + ' input[name="id"]');
    var value = Number((input && input.value) || root.dataset.variant);
    return isFinite(value) && value > 0 ? value : undefined;
  }

  // Resolves to 'ok', 'invalid' (the service refused the address) or 'error' (anything else).
  function send(root, email) {
    var p = parts(root);
    var controller = new AbortController();
    var timer = setTimeout(function () { controller.abort(); }, TIMEOUT_MS);

    return fetch(root.dataset.endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        email: email,
        handle: root.dataset.handle,
        variant_id: currentVariant(root),
        hp: p.hp ? p.hp.value : '',
      }),
      signal: controller.signal,
    })
      .then(function (response) {
        return response
          .json()
          .catch(function () { return null; })
          .then(function (data) {
            if (response.ok && data && data.ok === true) return 'ok';
            if (response.status === 400 && data && data.error === 'Correo inválido') return 'invalid';
            return 'error';
          });
      })
      .catch(function () { return 'error'; })
      .then(function (outcome) {
        clearTimeout(timer);
        return outcome;
      });
  }

  function submit(root) {
    if (root.dataset.state === 'sending') return;

    var p = parts(root);
    var email = p.input.value.trim();

    if (!EMAIL_RE.test(email)) {
      setState(root, 'invalid');
      p.input.focus();
      return;
    }

    setState(root, 'sending');
    send(root, email).then(function (outcome) {
      if (outcome === 'ok') {
        p.email.textContent = email;
        setState(root, 'success');
        p.done.focus({ preventScroll: true });
      } else if (outcome === 'invalid') {
        setState(root, 'invalid');
        p.input.focus();
      } else {
        setState(root, 'neterror');
        p.btn.focus();
      }
    });
  }

  document.addEventListener('submit', function (event) {
    var root = event.target.closest && event.target.closest('[data-iw-notify]');
    if (!root) return;
    event.preventDefault();
    submit(root);
  });

  // Typing clears an error and shows the check once the address looks right.
  document.addEventListener('input', function (event) {
    var root = event.target.closest && event.target.closest('[data-iw-notify]');
    if (!root || !event.target.matches('[data-notify-input]')) return;

    var p = parts(root);
    p.field.classList.toggle('is-valid', EMAIL_RE.test(p.input.value.trim()));
    if (root.dataset.state === 'invalid' || root.dataset.state === 'neterror') setState(root, 'idle');
  });

  document.addEventListener('click', function (event) {
    var again = event.target.closest && event.target.closest('[data-notify-again]');
    if (!again) return;

    var root = again.closest('[data-iw-notify]');
    var p = parts(root);
    setState(root, 'idle');
    p.input.focus();
    p.input.select();
  });

  /*
    On phones the Shopify Inbox bubble ("Chatea con …", <shopify-chat>, fixed bottom-left) sat on top of the card's
    button. While a card is on screen (below 990px) the bubble is hidden, and it comes back as soon as the card scrolls
    away. An open chat is never hidden. The hide is an inline style because the widget's own styles beat a stylesheet
    rule on <shopify-chat>. The cards are looked up on every check (not observed once), so a card swapped in by a
    section re-render is still seen.
  */
  var PHONE = window.matchMedia('(max-width: 989px)');
  var checkQueued = false;

  function checkInView() {
    checkQueued = false;
    var inView =
      PHONE.matches &&
      Array.prototype.some.call(document.querySelectorAll('[data-iw-notify]'), function (card) {
        var rect = card.getBoundingClientRect();
        return rect.height > 0 && rect.bottom > 0 && rect.top < window.innerHeight;
      });
    Array.prototype.forEach.call(document.querySelectorAll('shopify-chat'), function (chat) {
      if (inView && !chat.hasAttribute('open')) {
        chat.style.setProperty('display', 'none');
      } else {
        chat.style.removeProperty('display');
      }
    });
  }

  function queueCheck() {
    if (checkQueued) return;
    checkQueued = true;
    requestAnimationFrame(checkInView);
  }

  window.addEventListener('scroll', queueCheck, { passive: true });
  window.addEventListener('resize', queueCheck);
  // The chat widget loads on its own schedule, so check again once the page and the widget have had time to load.
  window.addEventListener('load', queueCheck);
  setTimeout(queueCheck, 3000);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', queueCheck);
  } else {
    queueCheck();
  }
})();
